import { Grid, makeStyles } from '@material-ui/core'
import LinkButton from 'components/common/buttons/LinkButton'
import { Check2 } from 'components/common/icons'
import Chatbubble1 from 'components/common/icons/Chatbubble1'
import React from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  root: {
    marginLeft: 50,
    marginTop: 4
  }
}))

const NeedsAttentionNoteActions = ({ canReply = true, onReplyClicked, onResolveClicked, isSaving }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Grid container spacing={2} className={classes.root}>
      {canReply && (
        <Grid item>
          <LinkButton
            id="needs-attention-note-reply"
            label={t('dialogs.patientBriefQuickActions.reply')}
            fontSize={14}
            underline
            onClick={onReplyClicked}
            icon={<Chatbubble1 />}
            disabled={isSaving}
          />
        </Grid>
      )}
      <Grid item>
        <LinkButton
          id="needs-attention-note-resolve"
          label={t('dialogs.patientBriefQuickActions.resolve')}
          fontSize={14}
          underline
          onClick={onResolveClicked}
          isLoading={isSaving}
          icon={<Check2 width={15} height={10} />}
        />
      </Grid>
    </Grid>
  )
}

export default NeedsAttentionNoteActions
